import React from 'react';
import { toast } from 'react-toastify';
import POSNotification from '../components/POSNotification';
import { Notification } from '../interfaces/Notification';

export const showNotification = {
  success: (notification: Notification) => {
    toast(
      (props) => (
        <POSNotification {...props} {...notification} type="success" />
      ),
      notification.options
    );
  },
  error: (notification: Notification) =>
    toast(
      (props) => <POSNotification {...props} {...notification} type="error" />,
      notification.options
    ),
  info: (notification: Notification) =>
    toast(
      (props) => <POSNotification {...props} {...notification} type="info" />,
      notification.options
    ),
  warning: (notification: Notification) =>
    toast(
      (props) => (
        <POSNotification {...props} {...notification} type="warning" />
      ),
      notification.options
    ),
};
